const AUTH_KEY = 'simplartisan-auth';

export const getSession = () => JSON.parse(localStorage.getItem(AUTH_KEY));

export const setSession = tokens =>
  localStorage.setItem(AUTH_KEY, JSON.stringify(tokens));

export const clearSession = () => localStorage.removeItem(AUTH_KEY);
